<template>
  <PosterPage
    v-if="address"
    :key="`${address.year}/${address.posterNum}`"
    :year="address.year"
    :poster-num="address.posterNum" />
  <PosterGallery v-else-if="$route.name === 'Posters'" />
  <router-view v-else v-slot="{ Component }">
    <!-- Or, here is where other poster pages will load (e.g., Upload) -->
    <!-- <keep-alive> is needed here AND in App.vue -->
    <!-- <keep-alive> NOT <keepAlive> -->
    <!-- :key must be on <component>, not on keep-alive -->
    <keep-alive>
      <component :is="Component" :key="$route.fullPath" />
    </keep-alive>
  </router-view>
</template>

<script setup>
import {useRoute} from "vue-router";
import PosterGallery from "@/components/PosterGallery.vue";
import PosterPage from "@/components/PosterPage.vue";
import {getPosterAddress} from "@/composables/usePosters.js";

const route = useRoute();
// a poster's own page, else the gallery: fixed for this instance (Main.vue keeps one alive per
// address; read live, a kept gallery would turn into the poster page opened from it)
const address = getPosterAddress(route);
</script>
